import HostInquirer from './HostInquirer'

class PlanOptionLinks extends HostInquirer {
    static get PREFIX() {
        return 'PicoPlan'
    }

    constructor(context) {
        super(context)
        this.initiated = false
    }

    // first we see what has the plan option link elements on the page
    init = (planOptions = []) => {
        if (!this.initiated) {
            this.initiated = true
            this.updateValues(planOptions)
        }
    }

    clickHandler = (e) => {
        e.preventDefault()

        const id = e.target.data?.id

        return this.context.Pico.handlePlanOptionLinkClick(id)
    }

    updateValues = (planOptions = []) => {
        planOptions.forEach((planOption) => {
            const className = `${PlanOptionLinks.PREFIX}_${planOption.short_code}`

            const elements = this.getAllElementsFromClassName(className)

            if (elements.length) {
                this.registerClassCallbacks({
                    id: planOption.plan_option_id,
                    elements,
                })
            }
        })
    }

    registerClassCallbacks = ({ elements, id }) => {
        elements.forEach((element) => {
            element.data = { id }
            element.removeEventListener('click', this.clickHandler)
            element.addEventListener('click', this.clickHandler)
        })
    }
}

export default PlanOptionLinks
